const handleCloseFormParamUser = {
  confirm: '¿Realmente desea salir sin guardar sus cambios?',
  title: 'CAMBIOS NO GUARDADOS'
};

export default handleCloseFormParamUser;
